import { isEmpty, isFunction, isUndefined } from 'lodash';

export const mediator = (() => {

    const _events = {};

    const _on = function(eventName, callback, callbackObject ) {
        if ( !isEmpty(eventName) && isFunction(callback) ) {
            if (isEmpty(_events[eventName])) {

                _events[eventName] = { callback, callbackObject };

                if( isUndefined( callbackObject ) ) {
                    _events[eventName].callbackObject = null;
                }

            } else {
                console.error('Event name already exist', _events[eventName]);
            }

        } else {
            console.error('Event name is not found and callback Should be a function.');
        }
    }

    const _off = function(eventName) {
        if (!isEmpty(eventName)) {
            if (!isEmpty(_events[eventName])) {
                delete _events[eventName];
            }

        } else {
            console.error('Event name is not found.');
        }
    }

    const _trigger = function(eventName, data = '') {
        if (!isEmpty(eventName)) {

            const _currentEvent = _events[eventName];

            if (!isEmpty( _currentEvent )) {

                if( isUndefined( _currentEvent.callbackObject ) ) {
                    _currentEvent.callback( data );
                } else {
                    _currentEvent.callback.call( _currentEvent.callbackObject, data );
                }

            } else {
                console.error('Event name is not register with mediator.', _events[eventName]);
            }
        } else {
            console.error('Event name is not found.');
        }
    }

    return {
        on: _on,
        off: _off,
        trigger: _trigger
    };

})();